import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["name", "label", "value", "onChange", "error", "id", "placeholder", "slotProps"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import theme from '../../../../theme/theme';
dayjs.extend(utc);
export var FormTimePicker = function (props) {
    var _a = props.name, name = _a === void 0 ? 'Time' : _a, label = props.label, value = props.value, onChange = props.onChange, error = props.error, id = props.id, placeholder = props.placeholder, _b = props.slotProps, slotProps = _b === void 0 ? {} : _b, others = _objectWithoutProperties(props, _excluded);
    return /*#__PURE__*/ React.createElement(LocalizationProvider, {
        dateAdapter: AdapterDayjs
    }, /*#__PURE__*/ React.createElement(TimePicker, _extends({
        name: name,
        value: value && dayjs(value),
        onChange: function (time) {
            var _dayjs$utc;
            return onChange === null || onChange === void 0 ? void 0 : onChange(null, time && ((_dayjs$utc = dayjs.utc(time)) === null || _dayjs$utc === void 0 ? void 0 : _dayjs$utc.format()));
        },
        desktopModeMediaQuery: theme.breakpoints.up('sm'),
        slotProps: {
            textField: _objectSpread(_objectSpread({
                id: id,
                size: "small",
                sx: {
                    mx: 0
                },
                fullWidth: true
            }, slotProps.textField), {}, {
                error: !!error,
                helperText: error,
                placeholder: placeholder
            }),
            field: _objectSpread({
                clearable: true,
                onClear: function (e) { return onChange && onChange(e, null, 'clear'); }
            }, slotProps.field),
            openPickerButton: _objectSpread({
                id: name + '-open-picker-btn'
            }, slotProps.openPickerButton),
            actionBar: {
                actions: ['clear', 'cancel', 'accept'],
                disableSpacing: true
            }
        }
    }, others)));
};
